<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import BlockSection from './BlockSection.vue'
import { ProductTypeMenuBlock } from '@interfaces/menu.interface'
import { PopoverButton } from '@headlessui/vue'

defineProps<{
    block: ProductTypeMenuBlock,
}>()
</script>

<template>
    <BlockSection :title="$t('components.menu.catalog.product-type')">
        <ul class="grid grid-cols-6 list-none gap-x-3 gap-y-4">
            <li
                v-for="(item, itemIdx) in block.items"
                :key="itemIdx"
            >
                <PopoverButton
                    :as="Link"
                    :href="item.url"
                    class="flex flex-col h-full group"
                >
                    <div class="relative mb-2 overflow-hidden rounded-xl aspect-square">
                        <div class="bg-white aspect-square">
                            <img
                                :srcset="`/images/menu/product-types/${item.type}.jpg, /images/menu/product-types/${item.type}@2x.jpg 2x, /images/menu/product-types/${item.type}@3x.jpg 3x`"
                                :src="`/images/menu/product-types/${item.type}.jpg`"
                                :alt="item.name"
                                class="object-cover w-full max-w-full transition-transform duration-300 transform group-hover:scale-105"
                                loading="lazy"
                                importance="auto"
                            >
                        </div>

                        <div class="absolute inset-0 bg-grayscale-900 transition-colors bg-opacity-[0.02] group-hover:bg-opacity-[0.04]"></div>
                    </div>

                    <span class="font-normal text-center text-p2 text-grayscale-800 group-hover:text-primary-800">{{ item.name }}</span>
                </PopoverButton>
            </li>
        </ul>
    </BlockSection>
</template>
